import { TabsTrigger } from "@radix-ui/react-tabs";
import { styled } from "@vitality-ds/system";
import BaseTabStyles from "./styles/BaseTab.styles";
export default styled(TabsTrigger, BaseTabStyles);